import { Box, Typography, useTheme } from "@mui/material";
import { usePropertyContext } from "../context/usePropertyContext";
import { FoodsIcon } from "@foodpilot/foods";

export const ErrorMessages = () => {
    const theme = useTheme();
    const { attachmentState } = usePropertyContext();

    const messages = attachmentState.errorMessages;

    if (messages.length === 0) {
        return null;
    }

    return (
        <Box display="flex" alignItems="center" sx={{ width: "100%", color: theme.palette.error.main }}>
            <FoodsIcon icon="warning" size={2} />
            <Typography
                variant="body-regular"
                sx={{
                    marginLeft: theme.spacing(0.5),
                    color: theme.palette.error.main,
                }}
            >
                {messages.map((message, index) => (
                    <div key={`${message}-${index}`}>{message}</div>
                ))}
            </Typography>
        </Box>
    );
};
